var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#building';
                    var viewUrl = 'svg/icons.svg#view-building';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 22 22',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };